export function getAiSettingsRoute(workspaceSlug: string | undefined) {
	return {
		name: 'settings.ai',
		params: { workspace: workspaceSlug },
	};
}
